// extracted by mini-css-extract-plugin
export default {"section":"Schulleben_section__FYsfO","text":"Schulleben_text__bBWCv"};